import { DecimalPipe, KeyValuePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';

import { CatalogCovinBadgeComponent } from '@core/ui';

import { CatalogData } from '../../../models';
import { TaskInfoComponent } from '../../task-info/task-info.component';

@Component({
  selector: 'mp-catalog-card-footer',
  templateUrl: './catalog-card-footer.component.html',
  styleUrl: './catalog-card-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, KeyValuePipe, MatButton, CatalogCovinBadgeComponent, TaskInfoComponent],
})
export class CatalogCardFooterComponent {
  readonly catalogData: InputSignal<CatalogData> = input.required<CatalogData>();

  readonly showAdditionalInfo: InputSignal<boolean> = input<boolean>(true);

  readonly openTaskIconMap: InputSignal<Record<string, string>> = input.required<Record<string, string>>();

  readonly catalogDetailsClick: OutputEmitterRef<string> = output<string>();

  protected readonly articleHasPictures: Signal<boolean> = computed(() => {
    const articleWithPicturesCount: number | undefined = this.catalogData().articleWithPicturesCount;

    return articleWithPicturesCount !== undefined && articleWithPicturesCount >= 0;
  });

  protected readonly catalogHasValidCovinRate: Signal<boolean> = computed(() => {
    const covinRate: number | undefined = this.catalogData().covinRate;

    return covinRate !== undefined && covinRate >= 0;
  });

  getTaskInfoIcon(taskInfoKey: string): string {
    return this.openTaskIconMap()[taskInfoKey];
  }

  navigateToDetails(): void {
    this.catalogDetailsClick.emit(this.catalogData().catalogId);
  }

  orginalSorting = () => 0;
}
